const newsletter = {
    portugues: {
        newspopupText1: 'Veja agora o ensaio sem censura da',
        newspopupText2: 'Fernanda Campos',
        newspopupText3: 'Insira seu e-mail e receba acesso',
        newspopupText4: 'GRÁTIS',
        newspopupText5: 'às fotos e vídeos exclusivos',
        newspopupPlaceholder: 'Digite seu e-mail aqui',
        newspopupButton: 'Acessar Ensaio Completo!',
        newspopupClose: 'Não gosto de mulher',
        newspopupCloseButton: 'Fechar',
        newspopupTitle: 'Bella da Semana',
    },
    ingles: {
        newspopupText1: 'See now the uncensored photoshoot with',
        newspopupText2: 'Fernanda Campos',
        newspopupText3: 'Enter your email and get',
        newspopupText4: 'FREE',
        newspopupText5: 'access to exclusive photos and videos',
        newspopupPlaceholder: 'Enter your email here',
        newspopupButton: 'Access Full Photoshoot!',
        newspopupClose: 'I dont like woman',
        newspopupCloseButton: 'Close',        
        newspopupTitle: 'Bella Club',
    }
  }
  
  export default newsletter
  